import { render, staticRenderFns } from "./Benefits.vue?vue&type=template&id=48bdfdef"
import script from "./Benefits.vue?vue&type=script&lang=js"
export * from "./Benefits.vue?vue&type=script&lang=js"
import style0 from "./Benefits.vue?vue&type=style&index=0&id=48bdfdef&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports